export { tload } from "./0x5c_TLOAD.js";
export { tstore } from "./0x5d_TSTORE.js";
export { sload } from "./0x54_SLOAD.js";
export { sstore } from "./0x55_SSTORE.js";
